export default __webpack_public_path__ + "static/media/TOM.729420a2.png";